import { Component, OnInit, OnDestroy } from '@angular/core';
import { finalize, map, Observable, shareReplay, Subscription } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { InvoicesSummary } from '@app/shared/interfaces/invoice.interface';
import { InvoicesService } from '../invoice/invoices.service';

@Component({
  selector: 'app-main-content',
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.scss'],
  standalone: false,
})
export class MainContentComponent implements OnInit, OnDestroy {
  error: boolean = false;
  summaryInvoicesRequest?: Subscription;
  invoicesSummary: InvoicesSummary | undefined;
  loadingSummary: boolean = false;

  ngOnInit() {
    this.getSummaryInvoices();
  }

  getSummaryInvoices(): void {
    this.loadingSummary = true;
    this.summaryInvoicesRequest = this.invoicesService
      .getInvoicesSummary()
      .pipe(
        finalize(() => {
          this.loadingSummary = false;
        }),
      )
      .subscribe({
        next: (response) => {
          this.invoicesSummary = response;
        },
        error: (error) => {
          console.error('Erreur lors de la récupération des factures', error);
          this.error = true;
        },
      });
  }

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map((result) => result.matches),
    shareReplay(),
  );

  constructor(
    public invoicesService: InvoicesService,
    private breakpointObserver: BreakpointObserver,
  ) {}

  ngOnDestroy(): void {
    this.summaryInvoicesRequest?.unsubscribe();
  }
}
